<script>
  export let color;
  export let borderRadius;
  export let opacity = null;

  // adding each color as conditional is required because tailwind can not load each color conditionally with JS template strings
</script>

<div
  class="square__cell m-auto w-[54px] h-[54px] h-xs:w-[54px] h-xs:h-[54px] sm:w-[66px] sm:h-[66px] md:w-[72px] md:h-[72px] md2:w-[84px] md2:h-[84px] lg:w-[90px] lg:h-[90px] xl:w-[116px] xl:h-[116px] transition-colors duration-[1000ms] ease"
  style="border-radius: {borderRadius}%; opacity: {opacity !== undefined ? opacity : 1}"
  class:bg-red={color === 'red'}
  class:bg-purple={color === 'purple'}
  class:bg-yellow-light={color === 'yellow'}
  class:bg-orange={color === 'orange'}
  class:bg-blue-dark={color === 'blue-dark'}
  class:bg-blue-light={color === 'blue-light'}
  class:bg-white={color === 'white'}
  class:bg-transparent={color === 'transparent'}
/>
